import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListPrice(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListPrice',
		componentId: uuidv4(),
		props: Object.assign(
			{
				textAlign: 'left',
				showListPrice: true,
			},
			props,
		),
		childrenComponents,
	};
}
